/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	MediaImageConfirmUploadPathParams,
	MediaImageConfirmUploadRequest,
	MediaImageConfirmUploadResponse,
} from '../types/MediaImageConfirmUpload'

/**
 * POST /media/:organisation/images/confirm
 * @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::confirmUpload
 */
export async function mediaImageConfirmUpload(
	organisation: MediaImageConfirmUploadPathParams['organisation'],
	data: MediaImageConfirmUploadRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MediaImageConfirmUploadResponse>> {
	return axiosInstance.post(`/media/${organisation}/images/confirm`, data, config)
}
